import React from 'react';
import { aboutDiagramUrl } from '../../assets/assetPaths';

function AboutOverlay({ t, setExpandedSection }) {
  return (
    <>
      <h2 id="overlay-heading" className="about-title">{t('about_title')}</h2>
      <figure className="overlay-figure overlay-figure--with-popout">
        <button
          type="button"
          className="section-popout-btn overlay-figure-popout-btn"
          onClick={() => setExpandedSection('about-diagram')}
          title={t('about_expand_diagram_title')}
          aria-label={t('about_expand_diagram_aria')}
        >
          ⤢
        </button>
        <img
          src={aboutDiagramUrl}
          alt={t('about_diagram_alt')}
        />
        <figcaption className="overlay-figure-caption">
          {t('about_diagram_caption')}
        </figcaption>
      </figure>
      <div className="overlay-article">
        <article className="article-content">
          <p className="article-intro">{t('about_intro')}</p>
          <section>
            <h3>{t('about_aimie_heading')}</h3>
            <p>{t('about_aimie_p1')}</p>
            <p>{t('about_aimie_p2')}</p>
            <figure className="overlay-figure">
              <table className="io-table" aria-label="AIMIE input and output">
                <thead>
                  <tr>
                    <th>{t('about_table_component')}</th>
                    <th>{t('about_table_description')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('about_table_input')}</td>
                    <td>
                      <strong>{t('about_table_input_traits')}</strong> {t('about_table_input_traits_desc')}<br />
                      <strong>{t('about_table_input_utterances')}</strong> {t('about_table_input_utterances_desc')}
                    </td>
                  </tr>
                  <tr>
                    <td>{t('about_table_output')}</td>
                    <td>
                      <strong>{t('about_table_output_smoker')}</strong> {t('about_table_output_smoker_desc')}<br />
                      <strong>{t('about_table_output_feedback')}</strong> {t('about_table_output_feedback_desc')}
                    </td>
                  </tr>
                </tbody>
              </table>
              <figcaption className="overlay-figure-caption">
                {t('about_table_caption')}
              </figcaption>
            </figure>
          </section>
          <section>
            <h3>{t('about_automics_heading')}</h3>
            <p>{t('about_automics_p1')}</p>
            <p>{t('about_automics_p2')}</p>
            <p className="about-citation">
              {t('about_citation_author')} <em>{t('about_citation_title')}</em>.
              {' '}
              <a href="https://www.eecg.utoronto.ca/~jayar/download/soliman_ali_masc_thesis.pdf" target="_blank" rel="noopener noreferrer">
                https://www.eecg.utoronto.ca/~jayar/download/soliman_ali_masc_thesis.pdf
              </a>
            </p>
          </section>
          <section>
            <h3>{t('about_llm_heading')}</h3>
            <p>{t('about_llm_p1')}</p>
            <p>{t('about_llm_p2')}</p>
          </section>
        </article>
      </div>
    </>
  );
}

export default AboutOverlay;
